export default __webpack_public_path__ + "static/media/image_demo_virtual_care.17705899.svg";